(function () {
  function initRankedCards(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-ranked-card]').forEach(function (card) {
      if (card.getAttribute('data-ranked-card-ready') === 'true') return;
      card.setAttribute('data-ranked-card-ready', 'true');

      var slides = Array.prototype.slice.call(card.querySelectorAll('.ranked-card__slide'));
      var dots = Array.prototype.slice.call(card.querySelectorAll('.ranked-card__dot'));
      var arrows = Array.prototype.slice.call(card.querySelectorAll('[data-slide-direction]'));
      var media = card.querySelector('[data-ranked-card-media]');
      var activeIndex = Math.max(0, slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      }));

      if (slides.length < 2) return;

      function showSlide(index) {
        activeIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach(function (dot, dotIndex) {
          var isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          showSlide(parseInt(dot.getAttribute('data-slide-target'), 10));
        });
      });

      arrows.forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var direction = arrow.getAttribute('data-slide-direction');
          showSlide(activeIndex + (direction === 'next' ? 1 : -1));
        });
      });

      if (media) {
        var startX = 0;
        var startY = 0;

        media.addEventListener('pointerdown', function (event) {
          startX = event.clientX;
          startY = event.clientY;
        });

        media.addEventListener('pointerup', function (event) {
          var deltaX = event.clientX - startX;
          var deltaY = event.clientY - startY;

          if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
            showSlide(activeIndex + (deltaX < 0 ? 1 : -1));
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRankedCards(document);
    });
  } else {
    initRankedCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initRankedCards(event.target);
  });
})();
